import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { scrollBarStyle, astriskStyle } from 'src/styles/CommonStyles.styled';
import { CURSOR} from '../../../styles/fonts/MCFontConstants';
export const TemplateContainer = styled.div`
    ${scrollBarStyle}
    padding-right: 8px;
    display: flex;
    flex-direction: column;
    height: ${({ height }) => (height ? height : '83%')};
    overflow-y: scroll;
    overflow-x: hidden;
    padding-bottom: ${({ paddingBottom }) =>
        paddingBottom ? paddingBottom : '0px'};
    ${media.mobileDevice`
    height: 100%;
    overflow-y: auto;
    overscroll-behavior-y: contain;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    margin: 4px;
    padding-right: 0px;
    &::-webkit-scrollbar {
        display: none;
    }
    `}
`;

export const FooterContainer = styled.div`
    position: absolute;
    bottom: 0;
    right: -16px;
    left: -16px;
    ${media.mediumDevice`
       margin-top: 17px;
    `};
`;
export const TemplateTitleContainer = styled.div`
    display: flex;
    flex-direction: row;
    margin: 4px 16px 0px 4px;
    justify-content: space-between;
    align-items: center;
    ${media.mobileDevice`
        margin: 21px 20px 0px 21px;
    `}
`;

export const TemplateTitle = styled.div`
    letter-spacing: 0px;
    color: #130e4a;
    opacity: 1;
    text-align: left;
    font-family: 'AvenirNextWorld Demi';
    font-size: 16px;
`;

export const Icon = styled.img.attrs((props) => ({
    src: props.mobilePath,
}))`
    width: 21px;
    height: 20px;
    cursor: ${CURSOR};
    ${media.mobileDevice`
    display: ${(props) => (props.display ? props.display : 'block')};
    `}
`;
export const Title = styled.div`
    letter-spacing: 0px;
    color: #140f4b;
    text-transform: uppercase;
    opacity: 1;
    font-size: 20px;
    text-align: left;
    line-height: 1.6;
    margin: 12px 24px 13px 24px;
    font-family: 'AvenirNextWorld Demi';
    order: 1;
    ${media.mobileDevice`
        order: 1;
        margin-right: 45px;
    `}
`;
export const SubContainerRows = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    ${media.smalDevice`
        flex-direction: column;
    `}
`;
export const LabelsContainer = styled.div`
    display: flex;
    flex-direction: row;
    margin: 4px 24px 21px 24px;
    align-items: center;
    justify-content: flex-start;
    order: 3;
    ${media.mobileDevice`
        order: 2;
    `}
`;
export const LabelItem = styled.div`
    background: #e8e8e8 0% 0% no-repeat padding-box;
    border-radius: 17px;
    opacity: 1;
    letter-spacing: -0.1px;
    color: #313131;
    opacity: 1;
    font-family: 'AvenirNextWorld Regular';
    margin-right: 16px;
    padding: 1px 6px;
    font-size: 14px;
`;

export const UserAndFavoritesContainer = styled.div`
    display: flex;
    flex-direction: row;
    margin: 4px 20px 21px 24px;
    align-items: center;
    justify-content: space-between;
    order: 2;
    ${media.mobileDevice`
        order: 3;
        margin: 4px 20px 8px 24px;
    `};
`;

export const UserNameAndDateContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-right: 26px;
    margin-left: 27px;
    ${media.mobileDevice`
       margin-right: auto;
    `};
    & .userName {
        letter-spacing: 0;
        text-align: left;
        font-family: 'AvenirNextWorld Demi';
        letter-spacing: 0px;
        color: #140f4b;
        opacity: 1;
        font-size: 14px;
    }

    & .dateStamp {
        text-align: left;
        font-family: 'AvenirNextWorld Regular';
        letter-spacing: -0.1px;
        color: #000000;
        opacity: 0.6;
        font-size: 14px;
        margin-top: -5px;
    }
`;
export const FavoriteIconContainer = styled.div`
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 2px #00000029;
    border: 1px solid #ebebeb;
    border-radius: 6px;
    opacity: 1;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: ${({ marginRight }) => marginRight};
`;

export const MoreInfoContainer = styled.div`
    background: #ffffff 0% 0% no-repeat padding-box;
    border-radius: 6px;
    opacity: 1;
    display: flex;
    flex-direction: column;
    margin: 0;
    /* ${media.mobileDevice`
       flex-direction: row;
       flex-wrap: wrap;
    `}; */
`;
export const CommonItemsMainContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    ${media.mobileDevice`
       flex-direction: column;
       width: 100%;
    `};
`;
export const CommonItemsContainer = styled.div`
    margin-top: ${({ hideMargin }) => (hideMargin ? '0px' : '20px')};
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '0px'};
    display: flex;
    flex-direction: column;
    flex-basis: ${({ flexbasis }) => (flexbasis ? flexbasis : '50%')};
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '19px')};
    margin-right: ${({ marginRight }) => (marginRight ? marginRight : '28px')};
    align-items: ${({ alignItemsCenter }) =>
        alignItemsCenter ? 'center' : ''};

    ${media.mobileDevice`
        flex-basis: 100%;
    `};
`;

export const AccountPhysicianProceduContainer = styled(MoreInfoContainer)`
    //margin: 2px;
    margin-top: 32px;
    flex-wrap: wrap;
    display: block;
    margin-bottom: ${({ marginbottom }) =>
        marginbottom ? marginbottom : '0px'};
    ${media.mobileDevice`
        margin-left: 16px;
        margin-right:16px;
        padding-top:16px;
        box-shadow: 0px 0px 6px #00000029;
    `};
`;

export const SetsAndItemsContainer = styled(MoreInfoContainer)`
    margin-top: 2px;
    margin-bottom: 8px;
`;

export const MoreInfoItemTitle = styled.div`
    letter-spacing: 0px;
    text-align: left;
    color: #202124;
    opacity: 1;
    font-family: 'AvenirNextWorld Demi';
    font-size: 18px;
    //margin: 0px 0px 0px 20px;
`;

export const MoreInfoItemValue = styled(MoreInfoItemTitle)`
    font-family: 'AvenirNextWorld Regular';
    //margin-bottom: 18px;
`;
export const DeleteIconView = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-right: ${({ paddingRight }) =>
        paddingRight ? paddingRight : '15px'};
`;
export const AccPhysProceTitle = styled(MoreInfoItemTitle)`
    font-family: 'AvenirNextWorld Demi';
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0px')};
    margin-right: ${({ marginRight }) => (marginRight ? marginRight : '0px')};
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '6px'};
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '20px')};
    font-size: 14px;
    ${astriskStyle};
`;
export const AccPhysProceValue = styled(MoreInfoItemTitle)`
    font-family: 'AvenirNextWorld Regular';
    padding-bottom: ${({ addExtraPadding }) =>
        addExtraPadding ? '21px' : '3px'};
    font-size: 16px;
`;
export const NoOptionalContainer = styled.div`
    padding-left: 15px;
`;

export const ChipContainer = styled.div`
    display: flex;
    flex-direction: row;
    margin: 0px 10px 0px 0px;
    align-items: center;
    justify-content: flex-start;
    & .chipName {
        font-size: 12px;
        font-family: 'AvenirNextWorld Regular';
        padding: 0px !important;
    }
    .MuiChip-label {
        font-size: 12px;
        font-family: 'AvenirNextWorld Regular';
    }
    .MuiChip-root {
        padding: 0px !important;
    }
    ${media.mobileDevice`
    margin: -12px 0px 0px 0px;
`}
`;

export const FavouriteIcon = styled.img.attrs((props) => ({
    src: props.mobilePath,
}))`
    width: 26px;
    height: 26px;
    display: block;
    cursor: pointer;
`;

export const CustomizeRowView = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    margin: 15px 4.5px 0px 4px;
    ${media.mobileDevice`
    margin-left: 16px;
    margin-right:7px;
    margin-bottom:0px;
    width: unset;
    flex-direction: row;
`};
`;

export const AutoCompleteDiv = styled.div`
    // width: 97%;
    // margin-left: 20px;
`;
export const AutoCompleteContainer = {
    width: '100%',
    marginTop: '10px',
};
export const RadioRowDiv = styled.span`
    display: inline-flex;
    width: ${({ width }) => (width ? width : '100%')};
    margin-bottom: ${({ marginBottom }) => marginBottom};
`;
export const RowContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-basis: 100%;
    ${media.mobileDevice`
    flex-direction:column;
    flex-basis: unset;
    `};
`;

export const AccountGroup = styled.div`
    flex-basis: 48%;
    ${media.mobileDevice`
    flex-basis: unset;
`};
`;

export const PhysicianGroup = styled.div`
    flex-basis: 48%;
    margin-left: 52px;
    ${media.mobileDevice`
        flex-basis: unset;
        margin-left: unset;
`};
`;

export const OptionalLoadMoreView = styled.div`
    background-color: #f5f5f5;
    height: ${({ height }) => (height ? height : '200px')};
    max-height: ${({ maxHeight }) => (maxHeight ? maxHeight : 'unset')};
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: scroll;
    margin: ${({ margin }) => (margin ? margin : '0px 0 0 0')};
    flex-direction: column;
    width: 100%;
    & p {
        color: #4f4f4f;
        font-size: 18px;
        /* width: 11em; */
        font-family: AvenirNextWorld Regular;
        word-break: break-word !important;
        text-align: center;
        margin-bottom: 20px;
    }
    & button {
        padding: 10px;
        color: #1010eb;
        border: 1px solid #1010eb;
        border-radius: 20px;
        text-align: center;
        padding: 5px 13px;
        font-family: AvenirNextWorld Demi;
        font-size: 15px;
        background: #f5f5f5;
    }
`;
export const MainContainerItems = styled.div`
    width: ${({ width }) => (width ? width : '47%')};
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '')};
    margin-bottom: ${({ setMarginBottom }) =>
        setMarginBottom ? '16px' : '0px'};
    padding: ${({ padding }) => (padding ? '' : '15px 24px 0px 29px')};
    ${media.mobileDevice`
        width: 100%;
        padding: 10px 24px 0px 32px;
    `};
`;

export const ExpirationTitle = styled.div`
    font-family: 'AvenirNextWorld demi';
    color: #202124;
    font-size: 14px;
    margin-bottom: 8px;

    &:after {
        content: '${(props) => (props.showAstrisk ? '*' : '')}';
        color: red;
        padding-left: 3px;
    }
`;
